function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 993.6,
  height: 993.6,
  x: 15,
  y: 15,
  fill: "#00a4ff",
  rx: 89.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M919 1024H105A105 105 0 010 919V105A105 105 0 01105 0h814a105 105 0 01105 105v814a105 105 0 01-105 105zM105 30a74 74 0 00-75 75v814a74 74 0 0075 75h814a74 74 0 0075-75V105a74 74 0 00-75-75z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff00b7",
  d: "M135 667h754s-38 251-377 251-377-251-377-251z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M290 869a280 280 0 01-153-194q87-5 174-7c41-1 91-9 131 0-41 21-78 37-107 75a220 220 0 00-33 60c-3 7-19 62-12 66zM504 809c-1 8-1 17 6 21 5 2 11 0 15-5s5-10 7-15c17-58 53-103 96-143-25 2-58-2-77 19-28 32-42 82-47 123z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M259 781c23 0 44-59 51-105h-94c4 45 21 105 43 105zM765 781c22 0 39-60 43-105h-94c7 46 28 105 51 105z",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M512 936c-182 0-279-72-329-132-55-66-65-131-65-134l-3-20h794l-3 20c0 3-11 68-65 134-50 60-147 132-329 132zM156 685c17 57 88 216 356 216 265 0 338-159 355-216z"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 512,
  cy: 400.2,
  r: 180.9,
  fill: "#00a397"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 512,
  cy: 400.2,
  r: 93.2
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 590.5,
  cy: 349.1,
  r: 51.8,
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M510 120c308 0 328 296 328 296s22 162-89 162H494",
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M514 120c-308 0-328 296-328 296s-22 162 89 162h255",
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 512,
  cy: 400.2,
  r: 180.9,
  fill: "#00a397"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 512,
  cy: 400.2,
  r: 93.2
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 590.5,
  cy: 349.1,
  r: 51.8,
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M855 415c-1-17-32-309-341-312h-4c-309 3-340 295-341 312-1 8-12 99 32 149 18 21 43 32 74 32h474c31 0 56-11 74-32 44-50 33-141 32-149zm-58 126a60 60 0 01-48 20H275c-20 0-36-7-48-20-34-39-24-122-24-122v-1c1-12 23-279 309-281 286 2 308 269 309 281v1c3 23 5 89-24 122z"
});

function SvgPodfriend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodfriend);
export default __webpack_public_path__ + "static/media/podfriend.91e5bfc9.svg";
export { ForwardRef as ReactComponent };